import * as React from 'react';

function RadioCheckIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g clipPath="url(#clip0_4380_5567)">
        <circle cx="8" cy="8.00006" r="8" className="fill-sf-act-electric-blue" />
        <path
          d="M6.81896 11.8601C6.50696 12.1721 6.00296 12.1721 5.69096 11.8601L2.81896 8.98809C2.50696 8.67609 2.50696 8.17209 2.81896 7.86009C3.13096 7.54809 3.63496 7.54809 3.94696 7.86009L6.25096 10.1641L11.755 4.66009C12.067 4.34809 12.571 4.34809 12.883 4.66009C13.195 4.97209 13.195 5.47609 12.883 5.78809L6.81896 11.8601Z"
          className="fill-icn-txt-prim-inv"
        />
      </g>
      <defs>
        <clipPath id="clip0_4380_5567">
          <rect y="6.10352e-05" width="16" height="16" rx="4" className="fill-icn-txt-prim-inv" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RadioCheckIcon;
